import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Autocomplete,
  Drawer,
  Divider,
  Chip,
  Skeleton,
} from "@mui/material";
import "../../App.css";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "../../providers/SnackbarProvider";
import { TableNodata } from "../../components/TableNodata";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import CustomPagination from "../../components/CustomPagination";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import HistoryIcon from "@mui/icons-material/History";
import { TableLoader } from "../../components/TableLoader";
import api from "../../api/client";
import { useChangeableItems, getLabelByKey, getPluralLabelByKey } from "../../store/useDynamicLabel";


// Helper function to format status display names
const formatStatusName = (status) => {
  if (!status) return "-";
  return status.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};

// time_limit is in minutes — may be a bare number ("30") or carry a unit ("30 Minutes").
// Normalize both to a uniform "N minute(s)".
const formatDuration = (t) => {
  if (t === null || t === undefined || t === "") return null;
  const n = parseFloat(String(t));
  if (!isNaN(n)) return `${n} ${n === 1 ? "minute" : "minutes"}`;
  return String(t).trim();
};

const QuestionPaperBuilder = () => {

  const changeableItems = useChangeableItems();
  const getLabel = (itemKey) => getLabelByKey(changeableItems, itemKey);
  const getPluralLabel = (itemKey) => getPluralLabelByKey(changeableItems, itemKey);

  const [showTable, setShowTable] = useState(false);
  const [openDrawer, setOpen] = useState(false);
  const location = useLocation();
  const { dashboard, viewAssessments, trainerId, testType, testTypeId, institute_id, studentId, studentName } = location.state || "";

  const [appliedProgram, setAppliedProgram] = useState(
    localStorage.getItem("applyProgram")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyProgram"));
        } catch {
          return null;
        }
      })()
      : null
  );
  const [appliedCategory, setAppliedCategory] = useState(
    localStorage.getItem("applyCategory")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyCategory"));
        } catch {
          return localStorage.getItem("applyCategory");
        }
      })()
      : null
  );
  const [appliedStatus, setAppliedStatus] = useState(
    localStorage.getItem("applyStatus") || null
  );
  const [appliedTrainer, setAppliedTrainer] = useState(
    localStorage.getItem("applyTrainer")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyTrainer"));
        } catch {
          return localStorage.getItem("applyTrainer");
        }
      })()
      : null
  );
  const [appliedTestType, setAppliedTestType] = useState(
    testType || localStorage.getItem("applyTestType") || null
  );
  const [appliedTestTypeId, setAppliedTestTypeId] = useState(
    testTypeId || +localStorage?.getItem("applyTestTypeId") || null
  );

  const [selectedProgram, setSelectedProgram] = useState(
    localStorage.getItem("applyProgram")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyProgram"));
        } catch {
          return null;
        }
      })()
      : null
  );
  const [selectedCategory, setSelectedCategory] = useState(
    localStorage.getItem("applyCategory")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyCategory"));
        } catch {
          return localStorage.getItem("applyCategory");
        }
      })()
      : null
  );
  const [selectedStatus, setSelectedStatus] = useState(
    localStorage.getItem("applyStatus") || null
  );
  const [selectedTrainer, setSelectedTrainer] = useState(
    localStorage.getItem("applyTrainer")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyTrainer"));
        } catch {
          return localStorage.getItem("applyTrainer");
        }
      })()
      : null
  );
  const instituteFromNav =
    location.state?.institute_id && location.state?.instituteName
      ? { institute_id: location.state.institute_id, name: location.state.instituteName }
      : null;
  const [selectedInstitute, setSelectedInstitute] = useState(
    instituteFromNav ||
    (localStorage.getItem("applyInstitute")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyInstitute"));
        } catch {
          return localStorage.getItem("applyInstitute");
        }
      })()
      : null)
  );
  const [appliedInstitute, setAppliedInstitute] = useState(
    instituteFromNav ||
    (localStorage.getItem("applyInstitute")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyInstitute"));
        } catch {
          return localStorage.getItem("applyInstitute");
        }
      })()
      : null)
  );
  const [selectedTestType, setSelectedTestType] = useState(
    testType || localStorage.getItem("applyTestType") || null
  );
  const [selectedTestTypeId, setSelectedTestTypeId] = useState(
    testTypeId || +localStorage?.getItem("applyTestTypeId") || null
  );

  const [selectedStudent, setSelectedStudent] = useState(
    localStorage.getItem("applyStudent")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyStudent"));
        } catch {
          return localStorage.getItem("applyStudent");
        }
      })()
      : null
  );
  const [appliedStudent, setAppliedStudent] = useState(
    localStorage.getItem("applyStudent")
      ? (() => {
        try {
          return JSON.parse(localStorage.getItem("applyStudent"));
        } catch {
          return localStorage.getItem("applyStudent");
        }
      })()
      : null
  );

  const [trainersList, setTrainersList] = useState([]);
  const [studentsList, setStudentsList] = useState([]);
  const [testTypes, setTestTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [institutes, setInstitutes] = useState([]);
  const [isTrainerSetFromNav, setIsTrainerSetFromNav] = useState(false);
  const [isStudentSetFromNav, setIsStudentSetFromNav] = useState(false);

  const { showSnackbar } = useSnackbar();
  const [listData, setlistData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);

  const headings = [
    { label: "S.No", align: "center" },
    { label: `${getLabel("PROGRAM_CODE")} / ${getLabel("PROGRAMS")}`, align: "left" },
    { label: `${getLabel("SUBJECT_CODE")} / ${getLabel("SUBJECT")}`, align: "left" },
    { label: `${getLabel('EXAM')} Type / ${getLabel('EXAM')} ID`, align: "left" },
    { label: "Paper Type / Status", align: "left" },
    { label: "Duration / Questions", align: "left" },
    { label: "Test Date / Created By", align: "left" },
    { label: "Status", align: "left" },
    { label: "Action", align: "left" },
  ];

  const handlechangeSearch = (e) => {
    setPage(0);
    setSearchKey(e.target.value);
  };

  const handleAddBuilder = () => {
    navigate("/questionPaperBuilder/create");
  };

  const handleApplyFilters = () => {
    setPage(0);
    setAppliedProgram(selectedProgram);
    localStorage.setItem("applyProgram", selectedProgram ? JSON.stringify(selectedProgram) : "");


    setAppliedCategory(selectedCategory);
    localStorage.setItem("applyCategory", selectedCategory ? JSON.stringify(selectedCategory) : "");


    setAppliedStatus(selectedStatus);
    localStorage.setItem("applyStatus", selectedStatus || "");

    setAppliedTrainer(selectedTrainer);
    localStorage.setItem("applyTrainer", selectedTrainer ? JSON.stringify(selectedTrainer) : "");

    setAppliedInstitute(selectedInstitute);
    localStorage.setItem("applyInstitute", selectedInstitute ? JSON.stringify(selectedInstitute) : "");

    setAppliedTestType(selectedTestType);
    localStorage.setItem("applyTestType", selectedTestType || "");

    setAppliedTestTypeId(selectedTestTypeId);
    localStorage.setItem("applyTestTypeId", selectedTestTypeId || "");

    setAppliedStudent(selectedStudent);
    localStorage.setItem("applyStudent", selectedStudent ? JSON.stringify(selectedStudent) : "");

    setOpen(false);
  };

  const fetchPrograms = async () => {
    try {
      const res = await api.post(localStorage.getItem("role") === "SUPER_ADMIN" ? "GetProgramsDropdown" : "GetAssignedProgramsDropdown", {});
      if (res?.data?.status === "success") {
        setPrograms(res?.data?.data || []);
      }
    } catch (error) {
      console.log("Error fetching programs:", error);
    }
  };

  const fetchCategories = async (programId) => {
    try {
      if (programId) {
        const res = await api.post("GetCategoriesByProgram", { program_id: programId });
        return (res?.data?.data || []).map((c) => ({ id: c.category_id, name: c.category_name }));
      }
      const res = await api.post("ListCategoryNamesWithIDs");
      return res?.data?.categories || [];
    } catch (error) {
      console.log("Error fetching categories:", error);
      return null;
    }
  };

  const fetchStatusOptions = async () => {
    try {
      const res = await api.post("ListStatus");
      if (res?.data?.status === "success") {
        setStatusOptions(res?.data?.status_names || []);
      }
    } catch (error) {
      console.log("Error fetching status options:", error);
    }
  };

  // Trainers matching the selected program and/or subject (all trainers when neither is picked)
  const fetchTrainers = async (instituteId, programId, categoryId) => {
    try {
      const payload = {
        institute_id: instituteId
          ? instituteId
          : +localStorage?.getItem("InstituteId") || null,
      };
      if (programId) payload.program_id = programId;
      if (categoryId) payload.category_id = categoryId;
      const res = await api.post("ListTrainersForFilter", payload);
      if (res?.data?.status === "success") {
        return res?.data?.data || [];
      }
      return null;
    } catch (error) {
      console.log("Error fetching trainers:", error);
      return null;
    }
  };

  const fetchTestTypes = async () => {
    try {
      const res = await api.post("/ListAssessmentTypes");
      if (res?.data?.status === "success") {
        setTestTypes(res?.data?.data || []);
      }
    } catch (error) {
      console.log("Error fetching test types:", error);
    }
  };

  const fetchInstitutes = async () => {
    try {
      const res = await api.post("ListInstituteNames");
      if (res?.data?.status === "success") {
        setInstitutes(res?.data?.data || []);
      }
    } catch (error) {
      console.log("Error fetching institutes:", error);
    }
  };

  const fetchStudents = async () => {
    try {
      const res = await api.post("/ListofStudentexam");
      if (res?.data?.status === "success") {
        setStudentsList(res?.data?.data || []);
      }
    } catch (error) {
      console.log("Error fetching students:", error);
    }
  };

  useEffect(() => {
    fetchPrograms();
    fetchStatusOptions();
    fetchTestTypes();
    fetchInstitutes();
    fetchStudents();
  }, []);

  useEffect(() => {
    if (instituteFromNav) {
      localStorage.setItem("applyInstitute", JSON.stringify(instituteFromNav));
      // Clear from location.state immediately so removing the chip won't re-trigger this
      const newState = { ...(location.state || {}) };
      delete newState.institute_id;
      delete newState.instituteName;
      navigate(location.pathname, { replace: true, state: newState });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (trainerId && trainersList.length > 0) {
      const trainer = trainersList.find((t) => t.trainer_id === trainerId || t.user_id === trainerId);
      if (trainer) {
        setSelectedTrainer(trainer);
        setAppliedTrainer(trainer);
        localStorage.setItem("applyTrainer", JSON.stringify(trainer));
        setIsTrainerSetFromNav(true);
        // Clear navigation state to prevent re-applying on refresh
        navigate(location.pathname, { replace: true, state: {} });
      } else {
        console.log(`${getLabel('TRAINER')} not found with ID:`, trainerId);
        console.log("Available trainers:", trainersList.map(t => ({ trainer_id: t.trainer_id, user_id: t.user_id, name: t.trainer_name || t.first_name })));
      }
    }
  }, [trainerId, trainersList]);

  // Auto-filter by student when navigating from TrainerDashboard
  useEffect(() => {
    if (studentId && studentsList.length > 0) {
      const student = studentsList.find((s) => s.student_id === studentId || s.user_id === studentId);
      if (student) {
        setSelectedStudent(student);
        setAppliedStudent(student);
        localStorage.setItem("applyStudent", JSON.stringify(student));
        setIsStudentSetFromNav(true);
        // Clear navigation state to prevent re-applying on refresh
        const newState = { ...(location.state || {}) };
        delete newState.studentId;
        delete newState.studentName;
        navigate(location.pathname, { replace: true, state: newState });
      } else {
        console.log(`${getLabel('STUDENT')} not found with ID:`, studentId);
      }
    }
  }, [studentId, studentsList, location.pathname, location.state, navigate]);

  // Handle testType from navigation state
  useEffect(() => {
    if (testType && testTypes.length > 0) {
      // Handle dashboard navigation where testTypeId might not be provided
      let targetTestTypeId = testTypeId;

      if (!targetTestTypeId) {
        const foundTestType = testTypes.find(type => type.test_type === testType);
        if (foundTestType) {
          targetTestTypeId = foundTestType.assessment_type_id;
        }
      }

      if (targetTestTypeId) {
        setSelectedTestType(testType);
        setAppliedTestType(testType);
        setSelectedTestTypeId(targetTestTypeId);
        setAppliedTestTypeId(targetTestTypeId);
        localStorage.setItem("applyTestType", testType);
        localStorage.setItem("applyTestTypeId", targetTestTypeId);

        // Clear navigation state to prevent re-applying on refresh/back
        const newState = { ...location.state };
        delete newState.testType;
        delete newState.testTypeId;
        navigate(location.pathname, { replace: true, state: newState });
      }
    }
  }, [testType, testTypeId, testTypes, location.pathname, location.state, navigate]);


  useEffect(() => {
    let ignore = false;
    fetchCategories(selectedProgram?.program_id).then((list) => {
      if (ignore || !list) return;
      setCategories(list);
      setSelectedCategory((prev) => (prev && !list.some((c) => c.id === prev.id) ? null : prev));
    });
    return () => {
      ignore = true;
    };
  }, [selectedProgram]);

  useEffect(() => {
    let ignore = false;
    fetchTrainers(institute_id, selectedProgram?.program_id, selectedCategory?.id).then((list) => {
      if (ignore || !list) return;
      setTrainersList(list);
      const trainerKey = (t) => t?.trainer_id || t?.user_id;
      setSelectedTrainer((prev) => (prev && !list.some((t) => trainerKey(t) === trainerKey(prev)) ? null : prev));
    });
    return () => {
      ignore = true;
    };
  }, [selectedProgram, selectedCategory]);

  useEffect(() => {
    const fetchQuestionPapers = async () => {
      setLoading(true);
      try {
        const payload = {
          page: page,
          size: rowsPerPage,
          search_key: searchKey || "",
        };

        if (appliedProgram) {
          payload.program_id = appliedProgram.program_id;
        }

        if (appliedCategory) {
          payload.category_id = appliedCategory.id;
        }

        if (appliedStatus) {
          payload.status = appliedStatus;
        }

        if (appliedTrainer) {
          payload.trainer_id = appliedTrainer.trainer_id || appliedTrainer.user_id;
        }

        if (appliedInstitute) {
          payload.institute_id = appliedInstitute.institute_id;
        }

        if (appliedTestTypeId) {
          payload.assessment_type_id = appliedTestTypeId;
        }

        if (appliedStudent) {
          payload.student_id = appliedStudent.student_id;
        }

        const res = await api.post("ListQuestionPapers", payload);
        if (res?.data?.status === "success") {
          setlistData(res?.data?.data || []);
          setCount(res?.data?.total || 0);
        } else {
          setlistData([]);
          setCount(0);
        }
      } catch (error) {
        console.log("Error:", error);
        setlistData([]);
        setCount(0);
      } finally {
        setLoading(false);
      }
    };

    // Only fetch if no trainerId from navigation OR if trainer is properly set
    console.log("API Call Check - trainerId:", trainerId, "isTrainerSetFromNav:", isTrainerSetFromNav, "appliedTrainer:", appliedTrainer);
    const shouldFetchForTrainer = !trainerId || (trainerId && isTrainerSetFromNav);
    const shouldFetchForStudent = !studentId || (studentId && isStudentSetFromNav);
    if (shouldFetchForTrainer && shouldFetchForStudent) {
      console.log("Calling fetchQuestionPapers with payload");
      fetchQuestionPapers();
    } else {
      console.log("Skipping API call - waiting for setup. trainer:", trainerId, "student:", studentId);
    }
  }, [page, rowsPerPage, searchKey, appliedProgram, appliedCategory, appliedStatus, appliedTrainer, appliedInstitute, appliedTestTypeId, appliedStudent, trainerId, isTrainerSetFromNav, studentId, isStudentSetFromNav]);

  const handleView = (assessment_id) => {
    navigate("/questionPaperBuilder/view", {
      state: {
        paper_id: assessment_id,
      },
    });
  };

  const handleClickClear = () => {
    setSelectedProgram(null);
    setAppliedProgram(null);
    localStorage.removeItem("applyProgram");
    setSelectedCategory(null);
    setSelectedStatus(null);
    setSelectedTrainer(null);
    setSelectedInstitute(null);
    setSelectedTestType(null);
    setSelectedTestTypeId(null);
    setAppliedCategory(null);
    setAppliedStatus(null);
    setAppliedTrainer(null);
    setAppliedInstitute(null);
    setAppliedTestType(null);
    setAppliedTestTypeId(null);
    setSelectedStudent(null);
    setAppliedStudent(null);
    setIsStudentSetFromNav(false);
    localStorage.removeItem("applyCategory");
    localStorage.removeItem("applyStatus");
    localStorage.removeItem("applyTrainer");
    localStorage.removeItem("applyInstitute");
    localStorage.removeItem("applyTestType");
    localStorage.removeItem("applyTestTypeId");
    localStorage.removeItem("applyStudent");
    setPage(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowTable(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", p: 1 }}>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            width: 320,
            p: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            height: "100vh",
            borderRadius: "12px 0 0 12px",
          },
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <FilterListIcon color="primary" />
            <Typography variant="h6" fontWeight={600} color="primary">
              Filters
            </Typography>
          </Box>
          <IconButton aria-label="Close" size="small" onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            {getLabel('PROGRAMS')}
          </Typography>
          <Autocomplete
            size="small"
            options={programs}
            getOptionLabel={(option) =>
              option?.program_code
                ? `[${option.program_code}] ${option.display_name || option.program_name || ""}`
                : option?.display_name || option?.program_name || ""
            }
            isOptionEqualToValue={(option, value) => option?.program_id === value?.program_id}
            value={selectedProgram}
            onChange={(event, newValue) => setSelectedProgram(newValue)}
            renderOption={(props, option) => (
              <li {...props} key={option.program_id}>
                {option.program_code ? `[${option.program_code}] ` : ""}
                {option.display_name || option.program_name}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} placeholder={`All ${getPluralLabel('PROGRAMS')}`} fullWidth variant="outlined" />
            )}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            {getLabel('SUBJECT')}
          </Typography>
          <Autocomplete
            size="small"
            options={categories}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            value={selectedCategory}
            onChange={(event, newValue) => setSelectedCategory(newValue)}
            renderInput={(params) => (
              <TextField {...params} placeholder={`All ${getPluralLabel('SUBJECT')}`} fullWidth variant="outlined" />
            )}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            {getLabel('TRAINER')}
          </Typography>
          <Autocomplete
            size="small"
            options={trainersList}
            getOptionLabel={(option) => option?.name || ""}
            isOptionEqualToValue={(option, value) => (option?.trainer_id || option?.user_id) === (value?.trainer_id || value?.user_id)}
            value={selectedTrainer}
            onChange={(event, newValue) => setSelectedTrainer(newValue)}
            renderInput={(params) => (
              <TextField {...params} placeholder="All Trainers" fullWidth variant="outlined" />
            )}
          />
        </Box>

        {/* Assessment Type */}
        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            {`${getLabel('EXAM')} Type`}
          </Typography>
          <Autocomplete
            size="small"
            options={testTypes}
            getOptionLabel={(option) => option?.test_type || ""}
            isOptionEqualToValue={(option, value) =>
              option.assessment_type_id === value?.assessment_type_id
            }
            value={
              testTypes.find(
                (item) => item.assessment_type_id === selectedTestTypeId
              ) || null
            }
            onChange={(event, newValue) => {
              setSelectedTestType(newValue ? newValue.test_type : null);
              setSelectedTestTypeId(
                newValue ? newValue.assessment_type_id : null
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select exam type"
                fullWidth
                variant="outlined"
              />
            )}
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={0.8}>
          <Typography variant="subtitle2" fontWeight={600}>
            Status
          </Typography>
          <Autocomplete
            size="small"
            options={statusOptions}
            getOptionLabel={(option) => option?.label || ""}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            value={statusOptions.find((o) => o.value === selectedStatus) || null}
            onChange={(event, newValue) => setSelectedStatus(newValue ? newValue.value : null)}
            renderInput={(params) => (
              <TextField {...params} placeholder="All Statuses" fullWidth variant="outlined" />
            )}
          />
        </Box>

        {localStorage.getItem("role") === "SUPER_ADMIN" && (
          <Box display="flex" flexDirection="column" gap={0.8}>
            <Typography variant="subtitle2" fontWeight={600}>
              {`${getLabel('INSTITUTE')}`}
            </Typography>
            <Autocomplete
              size="small"
              options={institutes}
              getOptionLabel={(option) => option?.name || ""}
              value={selectedInstitute}
              onChange={(event, newValue) => setSelectedInstitute(newValue)}
              renderInput={(params) => (
                <TextField {...params} placeholder="All Institutes" fullWidth variant="outlined" />
              )}
            />
          </Box>
        )}

        {localStorage.getItem("role") === "TRAINER" && (
          <Box display="flex" flexDirection="column" gap={0.8}>
            <Typography variant="subtitle2" fontWeight={600}>
              {getLabel('TRAINER')}
            </Typography>
            <Autocomplete
              size="small"
              options={studentsList}
              getOptionLabel={(option) => option?.student_name || ""}
              value={selectedStudent}
              onChange={(event, newValue) => setSelectedStudent(newValue)}
              renderInput={(params) => (
                <TextField {...params} placeholder="All Students" fullWidth variant="outlined" />
              )}
            />
          </Box>
        )}

        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="customButton"
          onClick={handleApplyFilters}
          sx={{ mt: 2 }}
        >
          Apply Filters
        </Button>
      </Drawer>

      {(dashboard === true || viewAssessments === true) && (
        <Grid
          item
          sx={{
            display: "flex",
            alignItems: "center",
            color: "#1c97e3",
            gap: "4px",
            cursor: "pointer",
            width: "fit-content",
            mb: 2,
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              window.history.back();
            }
          }}
          onClick={() => window.history.back()}
        >
          <ArrowBackIcon sx={{ fontSize: "17px" }} />
          <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1c97e3" }}>
            Back
          </Typography>
        </Grid>
      )}

      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 2,
            mb: 2,
          }}
        >
          <Grid>
            <Grid sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Box className="icon-box">
                <NoteAddIcon className="iconHeading" />
              </Box>
              <Box sx={{ ml: 2 }}>
                <Typography sx={{ fontSize: { xs: 20, sm: 28 }, fontWeight: 700, color: "#0a0a0a" }}>
                  {getLabel('QUESTION_PAPER')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid sx={{ display: "flex", gap: 4 }}>
            <TextField
              value={searchKey}
              size="small"
              variant="outlined"
              placeholder={`${getLabel("SUBJECT")} Search`}
              onChange={(e) => handlechangeSearch(e)}
              className="custom-search-field"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            {localStorage.getItem("role") !== "SUPER_ADMIN" && (
              <Button
                variant="contained"
                className="gradient-button"
                onClick={handleAddBuilder}
                startIcon={<AddIcon sx={{ color: "white" }} />}
              >
                <Typography sx={{ color: "white" }}>Create {getLabel('QUESTION_PAPER')}</Typography>
              </Button>
            )}
          </Grid>
        </Box>

        <TableContainer
          component={Paper}
          sx={{
            opacity: showTable ? 1 : 0,
            transform: showTable ? "translateY(0)" : "translateY(40px)",
            transition: "opacity 0.5s ease, transform 0.5s ease",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell colSpan={headings.length}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {appliedProgram && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedProgram.display_name || appliedProgram.program_name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedProgram(null);
                              setSelectedProgram(null);
                              setPage(0);
                              localStorage.removeItem("applyProgram");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedCategory && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedCategory.name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedCategory(null);
                              setSelectedCategory(null);
                              setPage(0);
                              localStorage.removeItem("applyCategory");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedStatus && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{formatStatusName(appliedStatus)}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedStatus(null);
                              setSelectedStatus(null);
                              setPage(0);
                              localStorage.removeItem("applyStatus");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedTrainer && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedTrainer.trainer_name || appliedTrainer.name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedTrainer(null);
                              setSelectedTrainer(null);
                              setIsTrainerSetFromNav(false);
                              setIsStudentSetFromNav(false);
                              setPage(0);
                              localStorage.removeItem("applyTrainer");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedInstitute && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedInstitute.name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedInstitute(null);
                              setSelectedInstitute(null);
                              setPage(0);
                              localStorage.removeItem("applyInstitute");
                              // Clear location.state so the auto-apply useEffect doesn't re-apply it
                              const newState = { ...(location.state || {}) };
                              delete newState.institute_id;
                              delete newState.instituteName;
                              navigate(location.pathname, { replace: true, state: newState });
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedTestType && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedTestType}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedTestType(null);
                              setSelectedTestType(null);
                              setSelectedTestTypeId(null);
                              setAppliedTestTypeId(null);
                              setPage(0);
                              localStorage.removeItem("applyTestType");
                              localStorage.removeItem("applyTestTypeId");
                              // Clear location.state so the auto-apply useEffect doesn't re-apply it
                              const newState = { ...(location.state || {}) };
                              delete newState.testType;
                              delete newState.testTypeId;
                              navigate(location.pathname, { replace: true, state: newState });
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                      {appliedStudent && (
                        <Box className="filter-chip">
                          <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>{appliedStudent.student_name}</Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setAppliedStudent(null);
                              setSelectedStudent(null);
                              setPage(0);
                              localStorage.removeItem("applyStudent");
                            }}
                            sx={{ ml: 0.5 }}
                          >
                            <CloseIcon sx={{ fontSize: '14px' }} />
                          </IconButton>
                        </Box>
                      )}
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <IconButton onClick={() => setOpen(true)} color="primary" className="more-filter-btn">
                        <FilterListIcon />
                        <Typography className="more-filter-text">More filter</Typography>
                      </IconButton>

                      {(appliedProgram || appliedCategory || appliedStatus || appliedTrainer || appliedTestType || appliedInstitute || appliedTestTypeId || appliedStudent) && (
                        <Button variant="outlined" className="clear-filter-btn" onClick={handleClickClear}>
                          Clear Filter
                        </Button>
                      )}
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow>
                {headings.map((heading, index) => (
                  <TableCell
                    key={index}
                    align={heading.align}
                    className="tableHeader"
                  >
                    <b>{heading.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody className="tablebody">
              {loading ? (
                <TableRow>
                  <TableCell colSpan={headings.length} align="center" sx={{ py: 4 }}>
                    <TableLoader message="Fetching questions..." />
                  </TableCell>
                </TableRow>
              ) : listData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={headings.length} align="center" sx={{ py: 10 }}>
                    <TableNodata />
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {listData.map((item, index) => (
                    <TableRow
                      key={item.assessment_id}
                      hover
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#FAFAFA" : "inherit",
                        "&:hover": { backgroundColor: "#f1f1f1" },
                      }}
                    >
                      {/* S.No */}
                      <TableCell align="center">
                        {page * rowsPerPage + index + 1}
                      </TableCell>

                      {/* Program: code + name */}
                      <TableCell sx={{ maxWidth: '200px' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                          {item.program_code && (
                            <Typography sx={{ fontWeight: 700, fontSize: '12px', color: '#1c97e3', letterSpacing: '0.3px' }}>
                              {item.program_code}
                            </Typography>
                          )}
                          <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a', wordBreak: 'break-word', lineHeight: 1.3 }}>
                            {item.program_name || "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Subject: category + code */}
                      <TableCell sx={{ maxWidth: '220px' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                          {item.category_code && (
                            <Typography sx={{ fontWeight: 700, fontSize: '12px', color: '#1c97e3', letterSpacing: '0.3px' }}>
                              {item.category_code}
                            </Typography>
                          )}
                          <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a', wordBreak: 'break-word', lineHeight: 1.3 }}>
                            {item.category_name || "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Level / Assessment Type */}
                      <TableCell>
                        <Box sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 0.5,
                          p: 0.6,
                          backgroundColor: '#f8fafc',
                          borderRadius: '6px',
                          border: '1px solid #e2e8f0'
                        }}>
                          <Chip
                            label={item.assessment_type_name}
                            size="small"
                            color={item.assessment_type_name === "Proctored Assessment" ? "secondary" : "primary"}
                            variant="filled"
                            sx={{ fontWeight: 600, fontSize: '10px', color: "white", height: '20px', borderRadius: '4px' }}
                          />
                          {item.level && (
                            <Chip
                              label={item.level}
                              size="small"
                              variant="outlined"
                              sx={{ fontWeight: 500, fontSize: '10px', height: '20px', borderRadius: '4px', color: '#64748b', borderColor: '#cbd5e1', backgroundColor: 'white' }}
                            />
                          )}
                          <Chip
                            label={`ASS - ${item.assessment_id}`}
                            size="small"
                            variant="outlined"
                            sx={{ fontWeight: 600, fontSize: '10px', height: '20px', borderRadius: '4px', color: '#475569', borderColor: '#cbd5e1', backgroundColor: 'white' }}
                          />
                        </Box>
                      </TableCell>

                      {/* Paper Type / Paper Status */}
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, p: 0.6, backgroundColor: '#f8fafc', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                          <Chip
                            label={item.paper_type || "—"}
                            size="small"
                            sx={{
                              fontWeight: 700,
                              fontSize: '10px',
                              height: '20px',
                              borderRadius: '4px',
                              letterSpacing: 0.3,
                              backgroundColor: item.paper_type === "RANDOM" ? "#eef2ff" : "#ecfeff",
                              color: item.paper_type === "RANDOM" ? "#4f46e5" : "#0e7490",
                              border: item.paper_type === "RANDOM" ? "1px solid #c7d2fe" : "1px solid #a5f3fc",
                            }}
                          />
                          {item.paper_status && (
                            <Chip
                              label={item.paper_status}
                              size="small"
                              sx={{
                                fontWeight: 600,
                                fontSize: '10px',
                                height: '20px',
                                borderRadius: '4px',
                                backgroundColor: item.paper_status === "APPROVED" ? "#e8f5e9" : "#fff3e0",
                                color: item.paper_status === "APPROVED" ? "#388e3c" : "#f57c00",
                              }}
                            />
                          )}
                        </Box>
                      </TableCell>

                      {/* Question Type / Duration / Questions */}
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                          {item.question_type && (
                            <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a' }}>
                              {item.question_type}
                            </Typography>
                          )}
                          {formatDuration(item.time_limit) && (
                            <Typography sx={{ fontSize: '11px', color: '#64748b', lineHeight: 1.4 }}>
                              ⏱ {formatDuration(item.time_limit)}
                            </Typography>
                          )}
                          {item.no_of_questions && (
                            <Typography sx={{ fontSize: '11px', color: '#64748b', lineHeight: 1.4 }}>
                              {item.no_of_questions} Questions
                            </Typography>
                          )}
                          {!item.question_type && !formatDuration(item.time_limit) && !item.no_of_questions && (
                            <Typography sx={{ fontWeight: 600, fontSize: '13px', color: '#1a1a1a' }}>-</Typography>
                          )}
                        </Box>
                      </TableCell>

                      {/* Scheduled Date / Created By (merged) */}
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                          <Typography sx={{ fontSize: '12px', color: '#546e7a', fontWeight: 500, lineHeight: 1.4 }}>
                            {item.scheduled_date ? new Date(item.scheduled_date).toLocaleDateString() : "-"}
                          </Typography>
                          <Typography sx={{ fontSize: '11px', color: '#888', lineHeight: 1.4 }}>
                            {item.created_by_name || "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            display: "inline-block",
                            px: 1.5,
                            py: 0.4,
                            borderRadius: "10px",
                            fontWeight: "bold",
                            fontSize: "11px",
                            backgroundColor:
                              item.status === "SCHEDULED"
                                ? "#e3f2fd"
                                : item.status === "READY"
                                  ? "#fff3e0"
                                  : item.status === "OPEN"
                                    ? "#e8f5e9"
                                    : item.status === "CLOSED"
                                      ? "#ffebee"
                                      : item.status === "COMPLETED"
                                        ? "#f3e5f5"
                                        : item.status === "CANCELLED"
                                          ? "#fce4ec"
                                          : "#f1f1f1",
                            color:
                              item.status === "SCHEDULED"
                                ? "#1976d2"
                                : item.status === "READY"
                                  ? "#f57c00"
                                  : item.status === "OPEN"
                                    ? "#388e3c"
                                    : item.status === "CLOSED"
                                      ? "#d32f2f"
                                      : item.status === "COMPLETED"
                                        ? "#7b1fa2"
                                        : item.status === "CANCELLED"
                                          ? "#c2185b"
                                          : "#333",
                            textAlign: "center",
                            textTransform: "capitalize",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatStatusName(item.status)}
                        </Box>
                      </TableCell>

                      <TableCell align="left" sx={{ whiteSpace: "nowrap" }}>
                        <Box display="flex" justifyContent="left" alignItems="center" gap={1.5}>
                          <IconButton
                            size="small"
                            onClick={() => handleView(item.assessment_id)}
                            sx={{ display: "flex", gap: 0.4, p: 0 }}
                          >
                            <VisibilityIcon color="primary" sx={{ fontSize: '18px' }} />
                            <Typography color="primary" sx={{ fontSize: "12px" }}>
                              View
                            </Typography>
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() =>
                              navigate("/examHistory", {
                                state: {
                                  // testType: item.assessment_type_name,
                                  category: item.category_name,
                                  // level: item.level,
                                  // testId: item.assessment_type_id,
                                  assessmentId: item.assessment_id,
                                },
                              })
                            }
                            sx={{ display: "flex", gap: 0.4, p: 0 }}
                          >
                            <HistoryIcon color="primary" sx={{ fontSize: '18px' }} />
                            <Typography color="primary" sx={{ fontSize: "12px" }}>
                              {`${getLabel('EXAM')} History`}
                            </Typography>
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}

                  {((page === 0 && listData?.length > rowsPerPage - 1) || page !== 0) && (
                    <CustomPagination
                      page={page}
                      setPage={setPage}
                      count={count}
                      rowsPerPage={rowsPerPage}
                      colSpan={headings.length}
                    />
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </>
    </Box>
  );
};

export default QuestionPaperBuilder;
